import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import Viagem from "model/viagem/Viagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import ViagemService from "service/viagem/ViagemService";
import ViagemTipoDespesaService from "service/viagem/ViagemTipoDespesaService";
import { converterData, converterDataHora } from "utils/convert";
import { IdListMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";
import saveAs from 'file-saver';
import { useToastContext } from "components/alert/ToastContext";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";

const viagemService = new ViagemService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ViagemListagem() {

    const [queryParameters] = useSearchParams();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [titulo, setTitulo] = useState<string>('Viagens');
    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);
    const [centrosCustoDisponiveis, setCentrosCustoDisponiveis] = useState<CentroCusto[]>([]);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_VIAGEM_LISTAGEM_EDITAR"])) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        viagemService.getUsuariosDisponiveis().then((response) => {
            setUsuariosDisponiveis(response)
        }).catch(err => {
            console.error(err);
        })
        viagemService.getCentroCustoDisponiveis().then((response) => {
            setCentrosCustoDisponiveis(response)
        }).catch(err => {
            console.error(err);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        situacao: {
            constraints: [
                {
                    value: ['1', '2', '3', '4', '5', '6'],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioSolicitante: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        centroCusto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataSolicitacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        itinerario: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        dataPartida: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataRetorno: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoLocomocao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        valorAdiantamento: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const usuarioFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={usuariosDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const centroCustoFilterTemplate = (options: ColumnFilterElementTemplateOptions, opcoes: any[]) => {
        return <MultiSelect value={options.value} options={opcoes}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    function getButtonsExtra() {
        return [
            editaRelatorios ? <SplitButton
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
            /> : <Button
                type="button"
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
            />
        ]
    }

    function gerarRelatorioListagem() {
        startLoading();
        viagemService.getRelatorioListagem(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Viagens.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    return (
        <>
            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_VIAGEM_LISTAGEM_EDITAR" titulo="Relatório de listagem" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <BaseListagem
                ordenacao="codigo,DESC"
                buttonsExtra={getButtonsExtra()}
                service={viagemService}
                urlService="/viagem"
                tituloPagina={titulo}
                defaultFilters={defaultFilters}
                showClearFilterButton
                showNewButton={false}
                nome="viagem" onChangeFilters={(filters) => setFilters(filters)}  >
                <Column
                    field="codigo" header="Nr."
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />

                <Column field="situacao" header="Situação" filterField="situacao"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, viagemService.getSituacaoFilter())}
                    body={(rowData) => viagemService.getSituacao(rowData.situacao)}
                />

                <Column
                    field="usuarioSolicitante.nome" header="Solicitante" filterField="usuarioSolicitante"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={usuarioFilterTemplate}
                />
                <Column
                    field="centroCusto.nome" header="Centro de custo" filterField="centroCusto"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => centroCustoFilterTemplate(options, centrosCustoDisponiveis)}
                />
                <Column
                    field="itinerario" header="Itinerário"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column field="tipoLocomocao" header="Locomoção" filterField="tipoLocomocao"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, viagemService.getTipoLocomocaoFilter())}
                    body={(rowData) => viagemService.getTipoLocomocao(rowData.tipoLocomocao)}
                />
                <Column field="dataSolicitacao" header="Dt. Solicitação" body={(rowData: Viagem) => converterData(rowData.dataSolicitacao)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataSolicitacao"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column field="dataPartida" header="Dt. Partida" body={(rowData: Viagem) => converterData(rowData.dataPartida)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataPartida"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column field="dataRetorno" header="Dt. Retorno" body={(rowData: Viagem) => converterData(rowData.dataRetorno)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataRetorno"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column
                    field="valorAdiantamento" header="Adiantamento" body={(rowData: Viagem) => rowData.valorAdiantamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
            </BaseListagem>
        </>
    )
}